import styles from '../../../ApplicationMaintenance.module.scss';
import { Button } from '@upmc/ims.component-library';
import MaterialIcon from '@material/react-material-icon';
import { useState } from 'react';
import Modal from '@mui/material/Modal';
import Base from '../../../../Base/Base';
import WQSystemForm from './WQSystemForm';
const WQSystemModal = ({
	appID,
	app,
	currentUser,
	requirementNumber,
	readOnly,
	isNew = false,
	setAppSystems,
}) => {
	const [modalOpen, setModalOpen] = useState(false);

	return (
		<div className={styles.controlsContainer}>
			<Button
				onClick={e => {
					setModalOpen(true);
				}}
				startIcon={<MaterialIcon icon='add' />}
				id='updateEmailNotifications_save'
				disabled={readOnly}
				variant='outlined'
			>
				{isNew ? 'Add WQ System' : 'Update'}
			</Button>
			<Modal
				open={modalOpen}
				onClose={() => {
					setModalOpen(false);
				}}
			>
				<div className={styles.Modal}>
					<Base
						title={isNew ? 'Add Work Queue' : 'Update Work Queue'}
					>
						<WQSystemForm
							appID={appID}
							app={app}
							currentUser={currentUser}
							requirementNumber={requirementNumber}
							readOnly={readOnly}
							isNew={isNew}
							setModalOpen={setModalOpen}
							setAppSystems={setAppSystems}
						/>
					</Base>
				</div>
			</Modal>
		</div>
	);
};

export default WQSystemModal;
